<!--Delete-->
<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    description="employees.header.permanentlyDeleteConfirm"
    [negative]="true"
    label="delete"
></app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmReallyDeleteDialog
    description="employees.header.permanentlyDeleteCertain"
    [negative]="true"
    label="employees.header.permanentlyDelete"
></app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #confirmRehire
    description="employees.header.rehireCertain"
    label="employees.header.rehire"
></app-deprecated-confirmation-dialog>

<ui-dialog
    #undoTerminationConfirmationDialog
    header="{{ 'employees.header.undoTermination' | translate }}"
    confirmationDialog
    (closing)="undoTerminationConfirmationDialog.open = false"
    (primaryButtonPressed)="undoTerminationConfirmationDialog.open = false; onUndoTermination()"
>
    <p>{{ 'employees.header.undoThisTerminationConfirm' | translate }}</p>
</ui-dialog>

<ui-dialog
    #undoRehireConfirmationDialog
    header="{{ 'employees.header.undoRehire' | translate }}"
    confirmationDialog
    (closing)="undoRehireConfirmationDialog.open = false"
    (primaryButtonPressed)="undoRehireConfirmationDialog.open = false; onUndoRehire()"
>
    <p>{{ 'employees.header.undoThisRehireConfirm' | translate }}</p>
</ui-dialog>

<ui-dialog
    header="{{ 'employees.leaveOfAbsenceDetails.leaveDetailsCap' | translate }}"
    [open]="isLeaveOfAbsenceDetailsModalOpen"
    (closing)="closeLeaveOfAbsenceModal()"
    size="small"
    [primaryButtonLabel]="null"
    [meatballMenu]="true"
    *ngIf="hasManageLeaveOfAbsence"
>
    <div class="meatballMenuItems">
        <button (click)="navigateToLeaveOfAbsenceEdit(); closeLeaveOfAbsenceModal()" mat-menu-item>
            {{ 'edit' | translate }}
        </button>
    </div>
    <app-leave-of-absence-details [employee]="employee"></app-leave-of-absence-details>
</ui-dialog>

<app-header
    [title]="'employees.header.employeeProfile'"
    [menuService]="employeeMenuService"
    [back]="true"
    [backRoute]="backRoute"
    [contextMenu]="auth.can(deleteEmployeePermission) && !isSelf"
>
    <div class="buttons">
        <ng-content select=".buttons"></ng-content>
        <ng-content select=".timeOff"> </ng-content>
    </div>

    <ng-container *permission="deleteEmployeePermission">
        <app-context-item
            *ngIf="hasManageLeaveOfAbsence && !employee?.onLeave && !leaveOfAbsenceScheduled"
            label="{{ 'employees.header.placeOnLeave' | translate }}"
            [routerLink]="placeOnLeaveUrl"
        ></app-context-item>

        <app-context-item
            *ngIf="hasManageLeaveOfAbsence && (employee?.onLeave || leaveOfAbsenceScheduled)"
            label="{{ 'employees.header.leaveDetails' | translate }}"
            (click)="openLeaveOfAbsenceModal()"
        ></app-context-item>

        <app-context-item
            *ngIf="employee?.status === 'onboarding' && !employee?.account?.isActive"
            label="{{ 'employees.header.resendInvite' | translate }}"
            (click)="resendAccountInvite(employee)"
        >
        </app-context-item>

        <app-context-item
            *ngIf="employee?.status !== 'terminated'"
            label="{{ 'employees.header.terminate' | translate }}"
            [routerLink]="terminateUrl"
        ></app-context-item>

        <ng-container *ngIf="canIssueRoe()">
            <app-context-item
                *permission="issueRoePermission"
                label="{{ 'employees.header.issueRoe' | translate }}"
                (click)="onIssueRoe()"
            ></app-context-item>
        </ng-container>

        <app-context-item
            *ngIf="employee?.isTerminated()"
            label="{{ 'employees.header.rehire' | translate }}"
            [routerLink]="['..', 'rehire']"
        ></app-context-item>

        <ng-container *ngIf="!employee?.activeOnPayroll()">
            <app-context-item
                label="{{ 'employees.header.delete' | translate }}"
                (click)="onDelete()"
            ></app-context-item>
        </ng-container>
    </ng-container>
</app-header>
<ui-banner *ngIf="isAdmin && employeeHasUpcomingTermination" class="d-block margin-bottom-3">
    <p>
        {{ 'employees.header.lastDayScheduledFor' | translate: { date: employee?.lastDayOfWorkOn | appDate } }}
        <a [routerLink]="[]" (click)="undoTerminationConfirmationDialog.open = true">{{
            'employees.header.undoThisTermination' | translate
        }}</a>
    </p>
</ui-banner>
<ui-banner *ngIf="isAdmin && employeeHasUpcomingRehire" class="d-block margin-bottom-3">
    <p>
        {{ 'employees.header.rehireScheduledFor' | translate: { date: employee?.nextDayOfWorkOn | appDate } }}
        <!--<a [routerLink]="" (click)="undoRehireConfirmationDialog.open = true">Undo this rehire.</a>-->
    </p>
</ui-banner>
